import React, { Component } from 'react';

import {TextInput, SelectInput} from './FormInputs.js';
import './basicforms.css';

class AddNewCuppingSessionForm extends Component {
  constructor(props) {
    super(props);
    let sessionDate = new Date();
    let day = sessionDate.getDate();
    day = (day>9 ? '' : '0') + day;
    let month = sessionDate.getMonth() + 1;
    month = (month>9 ? '' : '0') + month;
    this.state = {
      sessionName: 'CS ' + sessionDate.getFullYear() + month + day
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(id, value) {
    this.setState({
      [id]:value
    });
  }

  componentDidMount(){

    for(let i = 0;i < 10;i++) {
      //let sampleName = this.state.sessionName +' - ' + (i+1);
      let sampleName = 'Sample ' + (i>8 ? '' : '0') + (i+1);
      this.setState({
        [i]: sampleName
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    for (let i = 0; i < this.state.numberOfSamples; i++){
      this.props.dbRef.add({
        sessionName: this.state.sessionName,
        name: this.state.sessionName + ' ' + this.state[i],
        timeCreated: Date.now() //change to timestamp later
      })
      .then(docRef => {
        this.props.saveSession();
        console.log(docRef);
      })
      .catch(error => {
        console.log(error);
      });
    }
  }

  renderSampleFields(){

    let sampleFields = [];
    for(let i = 0;i < this.state.numberOfSamples;i++) {

      sampleFields.push(
        <div className="row" key={i}>
   				<div className="col-25">
   					<label>{'Sample: ' + (i+1)}</label>
   				</div>
   				<div className="col-75">
   					<TextInput type="text" dataId={i} value={this.state[i]} handleChange={this.handleChange} />
   				</div>
 	      </div>
      )
    }
    return(sampleFields);
  }

  render() {
    const nSamples = ['0','1','2','3','4','5','6','7','8','9','10'];
    //const deliveryDates = ["10-Oct-2018","10-Jan-2019"];


    return (



	<form className='basicforms' onSubmit={this.handleSubmit}>

		<div className='form_container'>
			<p className='pagetitle'>{this.props.name}</p>
			<div className="row">
				<div className="col-25">
					<label>Session Name</label>
				</div>
				<div className="col-75">
					<TextInput type="text" dataId="sessionName" value={this.state.sessionName} handleChange={this.handleChange}  />
				</div>
		    </div>
			<div className="row">
				<div className="col-25">
					<label>Description</label>
				</div>{/*
				<div className="col-75">
					<TextInput type="text" dataId="description" value={this.state.description} handleChange={this.handleChange}  />
				</div>*/}
		    </div>
		    <div className="row">
				<div className="col-25">
					<label>Number of Samples to Create</label>
				</div>
				<div className="col-75">
					<SelectInput selectItems={nSamples} dataId="numberOfSamples" value={this.state.numberOfSamples} handleChange={this.handleChange}  />
				</div>
		    </div>

        {this.renderSampleFields()}

        <div className="row">
				<div className="col-100">
					<input type="submit" value="Submit"/>
				</div>
		    </div>




		</div>

      </form>

    );
  }
}

export default AddNewCuppingSessionForm;



// WEBPACK FOOTER //
// ./src/components/AddNewCuppingSessionForm.js